import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

import type { BannerSize, BannerVariant } from '../../banner';

export const text = css`
  grid-area: title;
  justify-self: start;
  text-align: start;
`;

export const textVariant: Record<BannerVariant, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    color: ${theme.palette.primary.maxContrast};
  `,
  secondary: (theme) => css`
    color: ${theme.palette.tertiary.highContrast};
  `,
  warning: (theme) => css`
    color: ${theme.palette.warning.main};
  `,
  error: (theme) => css`
    color: ${theme.palette.error.main};
  `,
};

export const textSize: Record<BannerSize, (theme: Theme) => SerializedStyles> = {
  small: (theme) => css`
    font-size: ${theme.typography.app.bodySmMobile.fontSize}px;
    line-height: ${theme.typography.app.bodySmMobile.lineHeight}px;
    letter-spacing: ${theme.typography.app.bodySmMobile.letterSpacing}px;

    ${breakpoint.up('sm')} {
      font-size: ${theme.typography.app.caption.fontSize}px;
      line-height: ${theme.typography.app.caption.lineHeight}px;
      letter-spacing: ${theme.typography.app.caption.letterSpacing}px;
    }
  `,
  medium: (theme) => css`
    font-size: ${theme.typography.app.bodySmMobile.fontSize}px;
    line-height: ${theme.typography.app.bodySmMobile.lineHeight}px;
    letter-spacing: ${theme.typography.app.bodySmMobile.letterSpacing}px;

    ${breakpoint.up('sm')} {
      font-size: ${theme.typography.app.bodySm.fontSize}px;
      line-height: ${theme.typography.app.bodySm.lineHeight}px;
      letter-spacing: ${theme.typography.app.bodySm.letterSpacing}px;
    }
  `,
};

export const textUppercase = css`
  text-transform: uppercase;
`;
